import { sp } from '@main/theme';
import React from 'react';
import Form from 'react-bootstrap/Form';
import type { FormControlProps } from 'react-bootstrap/FormControl';
import styled from 'styled-components';

import { RequiredWrapper } from '../wrappers';
import { Description } from './Description';
import { FormItemWrapper, LabelWrapper } from './wrappers';

export const StyledFormControl = styled(Form.Control)`
  color: ${({ theme }) => theme.colors.textOnBg};
  display: block;
  width: 100%;
  padding: ${sp(1)};
  border-radius: ${sp(0.8)};
  border: 1px solid black;
`;

export interface IFormControlProps extends FormControlProps {
  /** The label for the form item */
  label: string;
  /** The description for the form item */
  description?: string;
  /** Indicate if form field is required */
  isRequired?: boolean;
  /** The name of the field */
  name: string;
}

export const StyledInput: React.FC<IFormControlProps> = ({
  label,
  description,
  isRequired,
  ...props
}) => (
  <FormItemWrapper>
    <LabelWrapper>
      {label}
      {isRequired && <RequiredWrapper>*</RequiredWrapper>}
      {description && (
        <Description
          descriptionHtml={description}
          id={`${props.name}-description`}
        />
      )}
    </LabelWrapper>
    <StyledFormControl {...props} />
  </FormItemWrapper>
);
